import StudentMapHeader from './StudentMapHeader';

/**
 * Wraps every student page with the map-style header (PokeMapNav + TrainerCard).
 * Excludes specific routes that have their own full-screen UI (e.g. /student/egg,
 * /student/duel) by passing `hideHeader` prop.
 */
export const StudentLayout = ({ children, hideHeader = false }) => {
  return (
    <div className="min-h-screen" data-testid="student-layout">
      {!hideHeader && <StudentMapHeader />}
      {children}
    </div>
  );
};

export default StudentLayout;
